import React, { useRef, useEffect } from 'react'
import './index.scss'

const LoadingContent = props => {
    const { text } = props
    const LoadingContent = useRef<HTMLDivElement>(null)
    useEffect(() => {
        const node = LoadingContent?.current
        node && node.addEventListener('touchmove', preventFn)
        return () => {
            node && node.removeEventListener('touchmove', preventFn)
        }
    }, [])

    const preventFn = e => {
        e.preventDefault()
    }

    return (
        <div className="loadingContent" ref={LoadingContent}>
            <div className="ldsBox">
                <div className="lds-spinner">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
                <div className="loadingText">{text}</div>
            </div>
        </div>
    )
}

export default LoadingContent
